__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@vision/shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(311), __webpack_require__.e(326), __webpack_require__.e(548)]).then(() => (() => (__webpack_require__(9548))))));
			register("@emotion/styled", "11.14.0", () => (Promise.all([__webpack_require__.e(326), __webpack_require__.e(284), __webpack_require__.e(114)]).then(() => (() => (__webpack_require__(4114))))));
			register("@mui/material", "9.2.0", () => (Promise.all([__webpack_require__.e(311), __webpack_require__.e(237), __webpack_require__.e(325), __webpack_require__.e(326), __webpack_require__.e(759), __webpack_require__.e(284), __webpack_require__.e(197)]).then(() => (() => (__webpack_require__(6237))))));
			register("@reduxjs/toolkit", "2.8.2", () => (__webpack_require__.e(151).then(() => (() => (__webpack_require__(6151))))));
			register("@tanstack/react-query", "5.97.0", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(326), __webpack_require__.e(49)]).then(() => (() => (__webpack_require__(4935))))));
			register("@vision/api-client", "1.7.0", () => (Promise.all([__webpack_require__.e(326), __webpack_require__.e(668), __webpack_require__.e(33), __webpack_require__.e(251)]).then(() => (() => (__webpack_require__(6251))))));
			register("@vision/auth-core", "1.6.0", () => (Promise.all([__webpack_require__.e(876), __webpack_require__.e(326), __webpack_require__.e(367)]).then(() => (() => (__webpack_require__(9876))))));
			register("@vision/security", "2.5.4", () => (Promise.all([__webpack_require__.e(81), __webpack_require__.e(410), __webpack_require__.e(326), __webpack_require__.e(367), __webpack_require__.e(460)]).then(() => (() => (__webpack_require__(6410))))));
			register("@vision/store", "1.3.1", () => (Promise.all([__webpack_require__.e(525), __webpack_require__.e(740)]).then(() => (() => (__webpack_require__(1740))))));
			register("react-dom/client", "19.2.4", () => (Promise.all([__webpack_require__.e(739), __webpack_require__.e(326), __webpack_require__.e(759)]).then(() => (() => (__webpack_require__(2739))))));
			register("react-dom", "19.2.4", () => (Promise.all([__webpack_require__.e(326), __webpack_require__.e(466)]).then(() => (() => (__webpack_require__(5466))))));
			register("react-hook-form", "7.74.0", () => (Promise.all([__webpack_require__.e(100), __webpack_require__.e(326)]).then(() => (() => (__webpack_require__(4100))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(978), __webpack_require__.e(326)]).then(() => (() => (__webpack_require__(597))))));
			register("react-router-dom", "7.13.1", () => (Promise.all([__webpack_require__.e(246), __webpack_require__.e(326), __webpack_require__.e(759)]).then(() => (() => (__webpack_require__(2246))))));
			register("react/jsx-runtime", "19.2.4", () => (__webpack_require__.e(349).then(() => (() => (__webpack_require__(6730))))));
			register("react", "19.2.4", () => (__webpack_require__.e(162).then(() => (() => (__webpack_require__(162))))));
			initExternal(8960);
			initExternal(4872);
			initExternal(9987);
			initExternal(8732);
			initExternal(5562);
			initExternal(7116);
			initExternal(9282);
			initExternal(756);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};